import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const InventoryRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.inventory_create === true ||
    permissions.inventory_edit === true ||
    permissions.inventory_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default InventoryRouteMiddleware;
